<template>
  <div id="app">
    <div class="top-img">
      <van-image width="300"  height="30" :src="info.topimg" />
    </div>
    <van-search @click="$router.push('/keyword')"  shape="round"  background="#ffb1b1" placeholder="请填写您的搜索信息"  />
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(image, index) in images" :key="index" @click="urllinks(image.link)">
        <img v-lazy="image.picurl"  />
      </van-swipe-item>
    </van-swipe>

    <van-image width="100%"  height="50" src="../../static/image/index1.png" />
    <div id="pad-w">
        <van-swipe :autoplay="5000" class="hntjlistbj" :show-indicators="false">
          <van-swipe-item v-for="(tjlist, index) in tjlist" :key="index" @click="tiao(tjlist.id)">
            <div class="hntj-img"><img v-lazy="tjlist.picurl"  /></div>
            <div class="hntj-botm">
              <van-button type="default" size="mini" class="mini-but-color mini-but-color-border">{{tjlist.ncnicknamenc}}</van-button>
              <van-button type="primary" size="mini" color="#f5f5f5" class="mini-but-color" >{{tjlist.birthday}}岁</van-button>
              <van-button type="primary" size="mini" color="#f5f5f5" class="mini-but-color">{{tjlist.xlname}}</van-button>
              <van-button type="primary" size="mini" color="#f5f5f5" class="mini-but-color">{{tjlist.sgname}}cm</van-button>
            </div>
            <div class="h-6"></div>
          </van-swipe-item>
        </van-swipe>
        <van-image width="100%"  height="50" src="../../static/image/index2.png" />
        <van-row type="flex" gutter="10"  justify="space-between">
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onJiazai" :immediate-check="immediate">
            <van-col span="12" v-for="(list, index) in list" :key="index" class="span12"  @click="tiao(list.id)">
              <img v-lazy="list.picurl"  @click="tiao(list.id)" />
              <van-button type="default" size="mini" class="mini-but-color mini-but-color-border mini-but--da">{{list.ncnicknamenc}}</van-button>
              <div class="hntj-botm-s">
                <van-button type="primary" size="mini" color="#f5f5f5" class="mini-but-color" >{{list.birthday}}岁</van-button>
                <van-button type="primary" size="mini" color="#f5f5f5" class="mini-but-color">{{list.xlname}}</van-button>
                <van-button type="primary" size="mini" color="#f5f5f5" class="mini-but-color">{{list.sgname}}cm</van-button>
              </div>
            </van-col>
          </van-list>
        </van-row>
    </div>
    <div class="h-50"></div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      info:[],
      images: [],
      tjlist: [],
      list: [],

      immediate:false,
      loading: false,
      finished: false,
      page: 1,//请求第几页
      total: 0,//总共的数据条数

    }
  },
  components: {
  },
  created:function () {
      this.$emit('footer', true);
  },

  mounted () {
    this.recordapi();
  },
  activated(){
      if(this.$route.meta.keepAlive){
          this.$emit('footer', true);
      }
  },
  	methods: {
      tiao(e){
        this.$router.push('Usercont?id='+e)
        console.log(e);
      },
      urllinks(e){
        this.$router.push(e)
        console.log(e);
      },
      recordapi(){
          var that = this;
          var userid = that.$cookieStore.getCookie('userid');
          that.$api.post("/Index/index",{'page':this.page}).then(res => {
            console.log(res);
             console.log(userid);
            that.info = res.info;
            that.images = res.info.banner
            that.tjlist = res.info.tjlist
            let rows = res.list.data; //请求返回当页的列表
            // // console.log(that.page);
            console.log(rows)
             that.loading  = false;
             that.pageSize = res.list.per_page;
             that.total    = res.list.total;
             if (rows == null || rows.length === 0) {
               // 加载结束
               that.finished = true;
               return;
             }
            // 将新数据与老数据进行合并
             that.list = that.list.concat(rows);
            // //如果列表数据条数>=总条数，不再触发滚动加载
            if(that.list.length >= that.total){
               that.finished = true;
            }
          });
      },
      // 加载
      onJiazai:function(){
        var that = this;
        that.page= that.page +1;
        console.log(that.page)
        that.recordapi()
      },
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Index.vue